export default __webpack_public_path__ + "static/media/card6.7797f636.png";